"use strict";
/**
 * Basic bot protection for the public HostShop forms (sign-up and contact):
 * a single-use nonce fetched when the form is shown, and a honeypot field
 * (the +form_guard_honeypot mixin) which people never see. Both are checked
 * by \StackShared\FormGuard on the server.
 */
class FormGuard {
    /**
     * @type {string} The form field for the nonce, as
     *     \StackShared\FormGuard::NONCE_FIELD
     */
    static get NONCE_FIELD() {
        return "form_nonce"
    }

    /**
     * @type {string} The honeypot form field, as
     *     \StackShared\FormGuard::HONEYPOT_FIELD
     */
    static get HONEYPOT_FIELD() {
        return "website"
    }

    /**
     * Fetches a nonce for one submission of the form. Fetch a new one
     * after each submission, since the server uses it up.
     *
     * @param {"signup" | "contact"} form
     * @returns {Promise<string>}
     */
    static nonce(form) {
        return $.ajax(`/a/formNonce/${form}`).then(r => r.nonce)
    }
}
